<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { chart } from "svelte-apexcharts";
  import { Totalselling } from "../../../../Data/Chart/Dashboard/Ecommerce/Chart";
  import {Month, Today, TotalSellings } from "../../../../utils/Constant/Constant";
</script>

<Col xl="6" class="box-col-6">
  <Card cardBodyprops="p-0">
    <div class="header-top d-sm-flex justify-content-between align-items-center" slot="customheader" >
      <h5>{TotalSellings}</h5>
      <div class="center-content">
        <ul class="week-date">
          <li class="font-primary">{Today}</li>
          <li>{Month}</li>
        </ul>
      </div>
    </div>
    <div slot="contentbody">
      <div id="chart-dash-2-line">
        <div use:chart={Totalselling} />
      </div>
    </div>
  </Card>
</Col>
